import { ErrorPage } from "@components/pages/ErrorPage"
import { SiteShell } from "@components/SiteShell"
import { getLegacyRedirect } from "@lib/redirects"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/$locale/$")({
  beforeLoad: ({ location }) => {
    const redirectTo = getLegacyRedirect(location.pathname)
    if (redirectTo) throw redirect({ href: redirectTo })
  },
  component: NotFound,
})

function NotFound() {
  const { locale: routeLocale } = Route.useParams()
  const locale = routeLocale === "en" || routeLocale === "ja" ? routeLocale : "ja"
  return (
    <SiteShell
      locale={locale}
      page="error404"
    >
      <ErrorPage locale={locale} />
    </SiteShell>
  )
}
